import {
    EMAIL_SENT,
    CALLER_CONNECTED
} from '../constants/p2a.js';

export const initialState = {
    response: {}
};

export function p2aReducer( state = initialState, action ) {

    switch ( action.type ) {

        case EMAIL_SENT:
        case CALLER_CONNECTED:
            return Object.assign( {}, state, {
                response: action.response
            });

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/p2a.js